export const initialValues = {
  is_active: 0,
  name: "",
  contact_details: "",
  address: "",
  extra_information: "",
  sort_order: 0,
};
